import { c as _c } from "react/compiler-runtime";
import { Chip } from "@flat-ui";
/**
 * @returns an orange chip to indicate that the feature is in beta
 */
export function BetaChip(t0) {
  const $ = _c(5);
  const {
    text: t1,
    sx
  } = t0;
  const text = t1 === undefined ? "BETA" : t1;
  let t2;
  if ($[0] !== sx) {
    t2 = {
      position: "relative",
      ...sx
    };
    $[0] = sx;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== text) {
    t3 = <Chip label={text} color="secondary" size="extraSmall" sx={t2} />;
    $[2] = t2;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}